// extracted by mini-css-extract-plugin
module.exports = {"icon":"_1P4hrnC1i0Z5lylp--qBXm"};